var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import InstanceCard from "./components/instance-card";
import { Helmet } from "react-helmet";
import { getData } from "./api";
var AnimateTitle = /** @class */ (function (_super) {
    __extends(AnimateTitle, _super);
    function AnimateTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimateTitle.prototype.componentDidMount = function () {
        var realTitle = document.title;
        setInterval(function () {
            document.title = document.title === realTitle ? "!!!! " + realTitle + " !!!!" : realTitle;
        }, 1000);
    };
    AnimateTitle.prototype.render = function () {
        return null;
    };
    return AnimateTitle;
}(React.Component));
var Dashboard = /** @class */ (function (_super) {
    __extends(Dashboard, _super);
    function Dashboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            data: [],
        };
        _this.fetch = function () {
            getData()
                .then(function (data) { return data.sort(function (a, b) { return b.sort > a.sort ? 1 : -1; }); })
                .then(function (data) { return _this.setState({ data: data }); })
                .catch(function (e) { return console.error("Failed to fetch monitoring data", e); });
        };
        return _this;
    }
    Dashboard.prototype.componentDidMount = function () {
        this.fetch();
    };
    Dashboard.prototype.render = function () {
        var data = this.state.data;
        var warn = data.find(function (i) { return i.warn; }) !== undefined;
        var alert = data.find(function (i) { return i.alert; }) !== undefined;
        return (React.createElement("div", { className: "dashboard" },
            data.map(function (i) { return React.createElement(InstanceCard, { key: i.name, instance: i }); }),
            (warn || alert) && React.createElement(AnimateTitle, null),
            React.createElement(Helmet, null, (function () {
                if (alert) {
                    return React.createElement("link", { rel: "icon", href: "/red-dot.png", type: "image/png" });
                }
                if (warn) {
                    return React.createElement("link", { rel: "icon", href: "/orange-dot.png", type: "image/png" });
                }
                return React.createElement("link", { rel: "icon", href: "/green-dot.png", type: "image/png" });
            })())));
    };
    return Dashboard;
}(React.Component));
export default Dashboard;
